import Vue from 'vue'
// 查询新闻列表
export  function getNews(query) {
    return  Vue.prototype.$api.get("/comNews/listComNews", query)
}